import { render, staticRenderFns } from "./AreaLogadaLayout.vue?vue&type=template&id=af91a29a&"
import script from "./AreaLogadaLayout.vue?vue&type=script&lang=js&"
export * from "./AreaLogadaLayout.vue?vue&type=script&lang=js&"
import style0 from "./AreaLogadaLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports